import axios from "axios";
export const state = {
    pay_type: [
        { name: 'Personal Bill', id: '0' },
        { name: 'Insurance Bill', id: '1' },
    ],
    insurance_services: [],
    insurance_patients: [],
    insurance_invoices: [],
    insurance_company_invoice: {},
    insuranceInvoiceStatus: false,
    insuranceStatus: false,
    insurance_companies: [],
    insurance_companies_packages: [],
    payments_ins_reciept: {},
    payments_ins_reciept_rep: {},
    insurance_packages: [],
    package_services: [],
    package_servicesx: [],
    payments_ins_rep:[],
    statement: {
        clinic: "",
        due_amt: "",
        company: "",
        invoice: "",
        paymode: "",
        user: ""
    },
    print_ins_reciept: false
};

export const getters = {
    InsuranceCompanies: state => state.insurance_companies.data,
    Print_ins_reciept: state => state.print_ins_reciept,
    InsuranceStatus: state => state.insuranceStatus,
    Paymentsinsreciept: state => state.payments_ins_reciept,
    PaymentsinsrecieptRep: state => state.payments_ins_reciept_rep,
    PaymentsinsRep: state => state.payments_ins_rep,
    InsuranceCompaniesPackages: state => state.insurance_companies_packages.data,
    PackageServices: state => state.package_services,
    InsurancePackageServices: state => state.package_servicesx.data,
    Statement: state => state.statement,
    PaymentType: state => state.pay_type,
    InsurancePackages: state => state.insurance_packages.data,
    InsurancePatients: state => state.insurance_patients,
    InsuranceInvoices: state => state.insurance_invoices.data,
    InsuranceServices: state => state.insurance_services.data,
    InsuranceCompanyInvoice: state => state.insurance_company_invoice,
    InsuranceInvoiceStatus: state => state.insuranceInvoiceStatus,
};

export const mutations = {
    SET_INSURANCE_COMPANIES(state, newValue) {
        state.insurance_companies = newValue
    },
    SET_STATEMENT(state, newValue) {
        state.statement = newValue
    },
    SET_INSURANCE_PACKS(state, newValue) {
        state.insurance_packages = newValue
    },
    SET_INSURANCE_PACK_SERVICES(state, newValue) {
        state.package_servicesx = newValue
    },
    SET_PACKAGE_SERVICES(state, newValue) {
        state.package_services = newValue
    },
    SET_INSURANCE_STATUS(state, newValue) {
        state.insuranceStatus = newValue
    },

    PRINT_INSURANCE_RECIEPT(state, newValue) {
        state.print_ins_reciept = newValue
    },
    SET_INSURANCE_COMPANIES_PACKAGES(state, newValue) {
        state.insurance_companies_packages = newValue
    },
    SET_INSURANCE_SERVICES(state, newValue) {
        state.insurance_services = newValue
    },
    SET_INSURANCE_PATIENTS(state, newValue) {
        state.insurance_patients = newValue
    },
    SET_INSURANCE_INVOICES(state, newValue) {
        state.insurance_invoices = newValue
    },
    REMOVE_VIST_OBJECT(state, index) {
        state.insurance_patients.splice(index, 1);
    },
    SET_INSURANCE_COMPANY_INVOICE(state, newValue) {
        state.insurance_company_invoice = newValue
    },
    INSURANCE_COMPANY_INVOICE_STATUS(state, newValue) {
        state.insuranceInvoiceStatus = newValue
    },
    SET_INSURANCE_INVOICE_TEMPLATE(state) {
        state.insurance_company_invoice = {}
    },
    SET_INSURANCE_PAYMENTRECIEPT(state, newValue) {
        state.payments_ins_reciept = newValue
    },
    SET_INSURANCE_PAYMENTRECIEPT_REPRINT(state, newValue) {
        state.payments_ins_reciept_rep = newValue
    },
    SET_INSURANCE_COMPANIES_REPORT(state, newValue) {
        state.payments_ins_rep = newValue
    },
};

export const actions = {
    fetchInsuranceCompanies({ commit }) {
        axios.get('insurance_company').then(ic_res => {
            commit('SET_INSURANCE_COMPANIES', ic_res.data)
        })
    },
    fetchInsuranceCompaniesReport({ commit }) {
        axios.get('companies_repoert').then(ic_res => {
            commit('SET_INSURANCE_COMPANIES_REPORT', ic_res.data)
        })
    },
    fetchInsuranceCompaniesPackages({ commit }) {
        axios.get('insurance_packages').then(ip_res => {
            commit('SET_INSURANCE_COMPANIES_PACKAGES', ip_res.data)
        })
    },
    fetchInsuranceServices({ commit }) {
        axios.get('insurance_services').then(vp_res => {
            commit('SET_INSURANCE_SERVICES', vp_res.data)
        })
    },
    
    fetchInsurancePatients({ commit }) {
        axios.get('insurance_patient').then(ip_res => {
            commit('SET_INSURANCE_PATIENTS', ip_res.data)
        })
    },
    fetchInsuranceInvoices({ commit }) {
        axios.get('insurance_invoice').then(ii_res => {
            commit('SET_INSURANCE_INVOICES', ii_res.data)
        })
    },
    fetchCompany_Invoice({ commit }, invoice_id) {
        commit('INSURANCE_COMPANY_INVOICE_STATUS', true)
        axios.get(`insurance_invoice/${invoice_id}`).then(ii_res => {
            commit('SET_INSURANCE_COMPANY_INVOICE', ii_res.data)
            commit('INSURANCE_COMPANY_INVOICE_STATUS', false)
        })
    },
    fetchStatement({ commit }, data) {
        axios.post(`insurance_company_statement`, data).then(ii_res => {
            commit('SET_STATEMENT', ii_res.data)
        })
    },
    fetchInsurancePacks({ commit }, id) {
        axios.get(`insurance_packs/${id}`).then(res => {
            commit('SET_INSURANCE_PACKS', res.data)
        })
    },
    fetchPackageServices({ commit }, id) {
        axios.get(`insurance_serv/${id}`).then(res => {
            commit('SET_PACKAGE_SERVICES', res.data)
        })
    },
    fetchInsPackageServices({ commit }, id) {
        axios.get(`insurance_servx/${id}`).then(res => {
            commit('SET_INSURANCE_PACK_SERVICES', res.data)
        })
    },
    generateInsuranceInvoice({ commit, dispatch }, payload) {
        commit('INSURANCE_COMPANY_INVOICE_STATUS', true)
        axios.post('insurance_invoice', payload).then(g_res => {
            commit('INSURANCE_COMPANY_INVOICE_STATUS', false)

            if (g_res.data == 'Invoice generated successfully') {
                let message = { 'msg': "Invoice generated successfully" }
                dispatch('notification/success', message, { root: true })
                dispatch('fetchInsuranceInvoices')
            } else {
                let message = { 'msg': 'No invoice to generate for the provided details' }
                dispatch('notification/error', message, { root: true })

            }

        }).catch(() => {
            commit('INSURANCE_COMPANY_INVOICE_STATUS', false)
            let message = { 'msg': "Error Geneating Invoice" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // INSURANCE COMPANY
    addInsuranceCompany({ commit, dispatch }, payload) {
        commit('SET_INSURANCE_STATUS', true)
        axios.post('insurance_company', payload).then(() => {
            dispatch('fetchInsuranceCompanies')
            commit('SET_INSURANCE_STATUS', false)

            let message = { 'msg': "Company added successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_INSURANCE_STATUS', false)
            let message = { 'msg': 'Error adding Insurance Company' }
            dispatch('notification/error', message, { root: true })
        })
    },

    editInsuranceCompany({ commit, dispatch }, payload) {
        commit('SET_INSURANCE_STATUS', true)
        axios.put(`insurance_company/${payload.id}`, payload).then(() => {
            dispatch('fetchInsuranceCompanies')
            commit('SET_INSURANCE_STATUS', false)

            let message = { 'msg': "Company edited successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_INSURANCE_STATUS', false)
            let message = { 'msg': 'Error editing Insurance Company' }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteInsuranceCompany({ commit, dispatch }, payload) {
        commit('SET_INSURANCE_STATUS', true)
        axios.delete(`insurance_company/${payload.id}`).then(() => {
            dispatch('fetchInsuranceCompanies')
            commit('SET_INSURANCE_STATUS', false)

            let message = { 'msg': "Company added successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_INSURANCE_STATUS', false)
            let message = { 'msg': 'Error adding Insurance Company' }
            dispatch('notification/error', message, { root: true })
        })
    },

    // INSURANCE SERVICES
    changeServiceStatus({ commit, dispatch }, payload) {
        commit('SET_INSURANCE_STATUS', true)
        axios.post('changeservicestatus', payload).then(() => {
            // dispatch(`fetchPackageServices`,payload.package)
            commit('SET_INSURANCE_STATUS', false)

            let message = { 'msg': "Service status updated successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_INSURANCE_STATUS', false)
            let message = { 'msg': 'Error updating Service status' }
            dispatch('notification/error', message, { root: true })
        })
    },
    changeServiceStatusAll({ commit, dispatch }, pack) {
        commit('SET_INSURANCE_STATUS', true)
        axios.post('changeservicestatusall', pack).then(() => {
            // dispatch(`fetchPackageServices`,pack.package)
            commit('SET_INSURANCE_STATUS', false)

            let message = { 'msg': "All Services Added successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_INSURANCE_STATUS', false)
            let message = { 'msg': 'Error adding all Services' }
            dispatch('notification/error', message, { root: true })
        })
    },
    changeServicePrice({ commit, dispatch }, payload) {
        commit('SET_INSURANCE_STATUS', true)
        axios.post('changeserviceprice', payload).then(() => {
            // dispatch(`fetchPackageServices`,payload.package)
            commit('SET_INSURANCE_STATUS', false)

            let message = { 'msg': "Service price updated successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_INSURANCE_STATUS', false)
            let message = { 'msg': 'Error updating Service price' }
            dispatch('notification/error', message, { root: true })
        })
    },

    // INSURANCE Package
    addInsurancePackage({ commit, dispatch }, payload) {
        commit('SET_INSURANCE_STATUS', true)
        axios.post('insurance_packages', payload).then(() => {
            dispatch('fetchInsurancePacks', payload.company)
            commit('SET_INSURANCE_STATUS', false)

            let message = { 'msg': "Package added successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_INSURANCE_STATUS', false)
            let message = { 'msg': 'Error adding Insurance Package' }
            dispatch('notification/error', message, { root: true })
        })
    },

    editInsurancePackage({ commit, dispatch }, payload) {
        commit('SET_INSURANCE_STATUS', true)
        axios.put(`insurance_packages/${payload.id}`, payload).then(() => {
            dispatch('fetchInsurancePacks', payload.company)
            commit('SET_INSURANCE_STATUS', false)

            let message = { 'msg': "Package name updated successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_INSURANCE_STATUS', false)
            let message = { 'msg': 'Error updating Insurance Package name' }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteInsurancePackage({ commit, dispatch }, payload) {
        commit('SET_INSURANCE_STATUS', true)
        axios.delete(`insurance_packages/${payload.id}`).then(() => {
            dispatch('fetchInsurancePacks', payload.company)
            commit('SET_INSURANCE_STATUS', false)

            let message = { 'msg': "Package added successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_INSURANCE_STATUS', false)
            let message = { 'msg': 'Error adding Insurance Package' }
            dispatch('notification/error', message, { root: true })
        })
    },

    makeInsurancePayment({ commit, dispatch }, payload) {
        commit('INSURANCE_COMPANY_INVOICE_STATUS', true)
        commit('PRINT_INSURANCE_RECIEPT', false)
        axios.post('insurance_payments', payload).then((ii_res) => {
            commit('INSURANCE_COMPANY_INVOICE_STATUS', false)
            commit('PRINT_INSURANCE_RECIEPT', true)
            commit('SET_INSURANCE_INVOICES', ii_res.data)
            let message = { 'msg': "Payments made successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('INSURANCE_COMPANY_INVOICE_STATUS', false)
            let message = { 'msg': 'Error making Insurance payments' }
            dispatch('notification/error', message, { root: true })
        })
    },


    fetchInsurancePaymentsReceipt({ commit }, pay_id) {
        commit('INSURANCE_COMPANY_INVOICE_STATUS', true)
        axios.get(`insurance_pay_reciept/${pay_id}`).then((pres) => {
            commit('SET_INSURANCE_PAYMENTRECIEPT', pres.data)
            commit('INSURANCE_COMPANY_INVOICE_STATUS', false)
        }).catch(() => {
            commit('INSURANCE_COMPANY_INVOICE_STATUS', false)
        })
    },
    fetchInsurancePaymentsReceiptReprint({ commit }, ledger_id) {
        commit('INSURANCE_COMPANY_INVOICE_STATUS', true)
        axios.get(`insurance_pay_reciept_reprint/${ledger_id}`).then((pres) => {
            commit('SET_INSURANCE_PAYMENTRECIEPT_REPRINT', pres.data)
            commit('INSURANCE_COMPANY_INVOICE_STATUS', false)
        }).catch(() => {
            commit('INSURANCE_COMPANY_INVOICE_STATUS', false)
        })
    },
    edit_Insurance_Invoice({ commit,dispatch }, payload){
        commit('INSURANCE_COMPANY_INVOICE_STATUS', true)
        axios.put(`insurance_invoice/${payload.invoice_id}`,payload).then(() => {
            let message = { 'msg': "Edit made successfully" }
            dispatch('fetchCompany_Invoice',payload.invoice_id)
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('INSURANCE_COMPANY_INVOICE_STATUS', false)
        })
    }
};